export var antiDebug=function antiDebug(){// if (
//   process.env.NODE_ENV === 'development' ||
//   process.env.REGION_ENV === 'boe'
// ) {
//   return;
// }
// function block() {
//   setInterval(() => {
//     (function () {
//       return false;
//     }
//       ['constructor'](`debugger;${Math.random()}`)
//       ['call']());
//   }, 50);
// }
// try {
//   block();
// } catch (err) {}
};